import React, { useState, useEffect, useRef } from "react";
import api from "../lib/api";

export function Autocomplete({ field, value, onChange, placeholder, testid, className }) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const boxRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/suggestions`, { params: { field, q: value || "" } });
        setOptions(data);
      } catch {
        setOptions([]);
      }
    }, 180);
    return () => clearTimeout(t);
  }, [value, field]);

  useEffect(() => {
    const handler = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={boxRef}>
      <input
        data-testid={testid}
        className={
          "w-full h-10 px-3 rounded-md border border-input bg-card text-sm focus:outline-none focus:ring-2 focus:ring-ring/40 " +
          (className || "")
        }
        value={value || ""}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        autoComplete="off"
      />
      {open && options.length > 0 && (
        <div
          data-testid={`${testid}-options`}
          className="absolute z-50 mt-1 w-full max-h-52 overflow-auto rounded-md border border-border bg-popover shadow-lg"
        >
          {options.map((o) => (
            <button
              key={o}
              type="button"
              className="w-full text-left px-3 py-2 text-sm hover:bg-accent/10 transition-colors"
              onClick={() => {
                onChange(o);
                setOpen(false);
              }}
            >
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
